import MatchMedia from '../utils/matchMedia';

export default class FilterMobile {
    constructor() {
        this.matchMedia = new MatchMedia();
        this.ui = this.getUI();
        this.listen();
    }

    getUI() {
        return {
            filterContent : document.getElementById("actualities-filters-content")
        }
    }

    listen() {       
        this._resize();

        window.addEventListener("resize", () => {
            this._resize();
        });
    }

    _resize() {
        if (this.matchMedia.isMobile || this.matchMedia.isTablet) { // Mettre en place le aria-labelledby en dessous de 1024
            this.ui.filterContent.setAttribute("aria-labelledby", "actualities-filters-btn");
        } else { // supprimer le aria-labelledby à partir de 1024
            this.ui.filterContent.removeAttribute("aria-labelledby");

            if(this.ui.filterContent.style.display === "none") {
                this.ui.filterContent.removeAttribute("style");
            }
        }
    }
}